var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmlBot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.555 1.54327C13.125 -0.561732 9.98902 -0.502732 8.64002 1.65527L0.531024 14.6303C0.177816 15.195 -0.00638722 15.8491 0.000169114 16.5152C0.00672545 17.1813 0.203768 17.8316 0.568024 18.3893L9.05502 31.4033C10.445 33.5333 13.581 33.5333 14.97 31.4033L23.432 18.4283C23.8085 17.8516 24.006 17.1765 23.9996 16.4878C23.9932 15.7992 23.7832 15.1278 23.396 14.5583L14.555 1.54327ZM15.523 9.23027C15.218 14.6673 10.928 19.0463 5.51102 19.5243L12.013 29.4943L20.475 16.5203L15.523 9.23027Z",
    fill: "#0057FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmlBot);
export default __webpack_public_path__ + "static/media/aml-bot.95c3435dee6f9dd5012d0062ef42d6ac.svg";
export { ForwardRef as ReactComponent };